import React from "react";

import PageLayout from "@layout/PageLayout";

import DemographicDataBody from "./DemographicDataBody";
import { transformDemographicPageData } from "./transformDemographicPageData";
import {
	bulkRenderRichText,
	renderRichText,
} from "@utils/prismic-render-utils";

const renderRichTextFields = data => {
	const richTextFields = bulkRenderRichText(data, [
		"storymapUrl",
		"storymapLinkHeader",
		"additionalInformationLinks",
		"documentGroups",
	]);
	const documentGroups = data.documentGroups.map(group => ({
		...group,
		header: renderRichText(group.header),
	}));
	return { ...data, ...richTextFields, documentGroups: documentGroups };
};

const DemographicData = props => {
	const data = props.previewData
		? renderRichTextFields(transformDemographicPageData(props.previewData))
		: renderRichTextFields(props.pageContext.data);

	return (
		<PageLayout
			{...props}
			data={data}
			tocQuery="h2,h3"
			pageTitle="Demographic Data"
			renderPage={pageProps => <DemographicDataBody {...pageProps} />}
		/>
	);
};

export default DemographicData;
